import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { fmtDate } from '@/utils/dateFmt';

const API = process.env.REACT_APP_BACKEND_URL;
const REASON = {
  varios_pagamentos: { label: 'Vários pagamentos registados (não migrado)', cls: 'bg-amber-100 text-amber-800' },
  sem_prestacoes: { label: 'Programa ativo sem prestações', cls: 'bg-red-50 text-red-600' },
};

export default function InstallmentsToConfigurePage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => { axios.get(`${API}/api/installments/to-configure`).then(r => setData(r.data)).catch(() => setError('Não foi possível carregar a lista.')); }, []);
  return (
    <div data-testid="installments-to-configure-page">
      <h2 className="font-heading font-medium text-2xl text-brand-text mb-1">Prestações por configurar</h2>
      <p className="text-sm text-brand-muted mb-4">Programas ativos sem prestações e programas com vários pagamentos que não foram migrados automaticamente. Abre a ficha para configurar as prestações.</p>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {data && <p className="text-xs font-medium text-brand-text mb-3" data-testid="installments-to-configure-count">{data.count} {data.count === 1 ? 'caso pendente' : 'casos pendentes'}</p>}
      {data && data.count === 0 && <p className="text-sm text-brand-green py-6 text-center" data-testid="installments-to-configure-empty">Tudo configurado.</p>}
      <div className="space-y-2">
        {(data?.cases || []).map(c => (
          <div key={c.program_id} className="bg-white border border-brand-border rounded-2xl p-3 flex items-center justify-between gap-3 flex-wrap" data-testid={`to-configure-${c.program_id}`}>
            <div className="text-sm text-brand-text">
              <p className="font-medium">{c.patient_name || 'Sem nome'}</p>
              <p className="text-xs text-brand-muted">Programa {c.program}{c.program_value ? ` · ${Number(c.program_value).toFixed(2).replace('.', ',')} €` : ''} · {c.nutritionist || 'Sem nutricionista'}</p>
              <p className="text-xs text-brand-muted">{fmtDate(c.start_date)}{c.end_date ? ` a ${fmtDate(c.end_date)}` : ''}</p>
              <span className={`inline-block mt-1 text-[10px] px-2 py-0.5 rounded-full font-semibold ${REASON[c.reason]?.cls}`}>{REASON[c.reason]?.label}{c.payments_found ? ` (${c.payments_found})` : ''}</span>
            </div>
            <Link to={c.link} className="text-xs bg-brand-green text-white rounded-full px-3 py-1.5 no-underline" data-testid={`to-configure-open-${c.program_id}`}>Abrir ficha</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
